//@ts-nocheck

//Components
import ReportsResultPanel from './ReportsResultPanel/ReportsResultPanel';
import ShellLayout from '../../layouts/ShellLayout/ShellLayout';
import {
  ChartLineIcon,
  Users,
  CurrencyDollar,
  Warning,
  CreditCard,
  SquaresFour,
  Info
} from '@phosphor-icons/react';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
//import { useFlags } from 'launchdarkly-react-client-sdk';
import * as PropTypes from 'prop-types';
import './Reports.css';

import AIChat from '../../components/AIChat/AIChat';
//import { getTripBookingPassenger } from '../../services/booking/booking';

const SUGGESTION_CARDS = [
  {
    id: 1,
    icon: <Users size={18} />,
    text: 'Show me total bookings across all active trips',
    tags: ['Bookings', 'Trips']
  },
  {
    id: 2,
    icon: <CurrencyDollar size={18} />,
    text: 'Show me outstanding balances by trip',
    tags: ['Payments', 'Trips']
  },
  {
    id: 3,
    icon: <Warning size={18} />,
    text: 'Show me passengers with missing required information',
    tags: ['Passengers']
  },
  {
    id: 4,
    icon: <CreditCard size={18} />,
    text: 'Show me total payments collected this month',
    tags: ['Payments']
  },
  {
    id: 5,
    icon: <SquaresFour size={18} />,
    text: 'Show me bookings by trip status',
    tags: ['Bookings', 'Trips']
  },
  {
    id: 6,
    icon: <ChartLineIcon size={18} />,
    text: 'Show me trips with the most unpaid balances',
    tags: ['Trips', 'Payments']
  }
];

/**
 * Renders trip details page with tabs for different views (itinerary, pricing, etc)
 * @param {Object} props - Component props
 * @param {string} props.id - Trip component ID
 * @returns {JSX.Element} Trip page component
 */
const Reports = ({ id }) => {
  const { t } = useTranslation(['trip', 'common', 'trips']);
  //eslint-disable-next-line no-unused-vars
  const [isTripLoading, setIsTripLoading] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [customInput, setCustomInput] = useState('');

  const [resultData, setResultData] = useState(null);
  console.log('🚀 ~ Reports ~ resultData:', resultData);
  // const { tripNavigation, enableDisplayStatuses } = useFlags();

  //Ask a question to pull data from across all your trips. Powered by AI.
  return (
    <div id={id} className='reports'>
      <ShellLayout
        id='main-trip-header'
        data-testid='trip-shell'
        headerData={null}
        isLoadingContent={isTripLoading}
      >
        <div className='reports__wrapper'>
          <div className='reports__container'>
            <div className='reports-header'>
              <h2 className='reports__empty-state-title'>{t('Reports')}</h2>
              <p>
                Ask a question to pull data from across all your trips. Powered
                by AI.
              </p>
            </div>

            {/* Empty state */}
            <div className='reports__empty-state'>
              <div className='reports__empty-state-icon'>
                <ChartLineIcon size={24} strokeWidth={1.5} />
              </div>
              <h2 className='reports__empty-state-title'>
                {t('whatWouldYouLikeToKnow', 'What would you like to know?')}
              </h2>
              <p className='reports__empty-state-subtitle'>
                {t(
                  'reportsEmptyStateSubtitle',
                  'Ask a question in plain English. Reports pulls live data across all your trips and gives you a structured answer you can sort, filter, and export.'
                )}
              </p>

              {/* Suggestion cards grid */}
              <div className='reports__suggestions-grid'>
                {SUGGESTION_CARDS.map((card) => (
                  <button
                    key={card.id}
                    className='reports__suggestion-card'
                    onClick={() => setCustomInput(card.text)}
                  >
                    <div className='reports__suggestion-card-icon'>
                      {card.icon}
                    </div>
                    <div className='reports__suggestion-card-content'>
                      <span className='reports__suggestion-card-text'>
                        {card.text}
                      </span>
                      <span className='reports__suggestion-card-tags'>
                        {card.tags.join(' · ')}
                      </span>
                    </div>
                  </button>
                ))}
              </div>

              {/*  Info box */}
              <div className='reports__info-box'>
                <Info size={16} className='reports__info-box-icon' />
                <div className='reports__info-box-content'>
                  <span className='reports__info-box-title'>
                    What you can ask about
                  </span>
                  <p className='reports__info-box-text'>
                    {t(
                      'reportsInfoBox',
                      'Trips, bookings, passengers, and payments — across your entire tenant. Reports work on live data, so totals and statuses always match what you see in the app. We do not yet support custom date math, joins to external systems, or trip-level deep dives. Those are coming.'
                    )}
                  </p>
                </div>
              </div>
            </div>

            <div className='reports__ai-chat-container'>
              <AIChat
                isOpen={isChatOpen}
                onClose={() => setIsChatOpen(false)}
                contextType='global'
                onDataUpdate={() => {}}
                embedded={true}
                showInstructions={false}
                customInput={customInput}
                additionalInstructions={
                  'Alwways display results in a table format, and include all relevant columns.'
                }
                setResultData={setResultData}
              >
                {/* ── Result panel: parses markdown table, search/filter/export ── */}
                {resultData && <ReportsResultPanel resultData={resultData} />}
              </AIChat>
            </div>
          </div>
        </div>
      </ShellLayout>
    </div>
  );
};

Reports.propTypes = {
  id: PropTypes.string.isRequired
};

export default Reports;
